import { FeatureFlags } from '@constants/featureFlags';
import { openFeedbackPanel, type FeedbackTypeT } from '@store/feedback';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { Show } from 'solid-js';

type FeedbackTriggerProps = {
  /** Change-tracking source id, so feedback lands on the same component taxonomy as breadcrumbs. */
  source: ChangeTrackingSource;
  feedbackType?: FeedbackTypeT;
  /** `hover` fades in on parent `group` hover (cards); `static` is always visible (page headers). */
  variant?: 'hover' | 'static';
  class?: string;
};

export const FeedbackTrigger = (props: FeedbackTriggerProps) => {
  const hoverClasses = () =>
    (props.variant ?? 'hover') === 'hover'
      ? 'opacity-0 focus-visible:opacity-100 group-hover:opacity-100'
      : '';

  return (
    <Show when={isFeatureFlagEnabled(FeatureFlags.ReleaseProductFeedback)()}>
      <button
        type="button"
        title="Give feedback on this"
        aria-label="Give feedback on this"
        class={`grid h-9 w-9 cursor-pointer place-items-center rounded-md text-slate-500 transition-opacity hover:bg-slate-100 hover:text-sky-600 ${hoverClasses()} ${props.class ?? ''}`}
        onClick={() =>
          openFeedbackPanel(props.feedbackType ?? 'Problem', props.source)
        }
        data-testid={`feedback-trigger-${props.source}`}
      >
        <svg
          viewBox="0 0 24 24"
          class="h-5 w-5"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M21 12a8 8 0 1 1-3.2-6.4" stroke-linecap="round" />
          <path d="M8 12h8M8 9h5" stroke-linecap="round" />
        </svg>
      </button>
    </Show>
  );
};
